// JS for Comparison
import $ from "jquery";

$(document).on("click", ".add-base-product", function (e) {
  e.preventDefault();
  var $thisbutton = $(this);
  const productID = $(this).data("product-id");
  const toggleData = $(".product-" + productID + "-input").data(
    "toggle-switch-options"
  );
  const toggleInput = $(".product-" + productID + "-input");
  const isChecked = $(".product-" + productID + "-input").is(":checked");
  const variationID =
    isChecked == true
      ? toggleData.variation_id
      : toggleData.variation_id_default;
  const productName = toggleData.product_name;
  const variationName =
    isChecked == true
      ? toggleData.variation_name
      : toggleData.variation_default_name;
  var data = {
    action: "ql_woocommerce_ajax_add_to_cart",
    product_id: productID,
    product_type: "base-plan",
    quantity: 1,
    variation_id: variationID,
  };
  $(document.body).trigger("adding_to_cart", [$thisbutton, data]);
  $.ajax({
    type: "post",
    url: wc_add_to_cart_params.ajax_url,
    data: data,
    beforeSend: function (response) {
      $thisbutton.removeClass("added").addClass("loading");
    },
    complete: function (response) {
      $thisbutton.addClass("added").removeClass("loading");
    },
    success: function (response) {
      refresh_notices();
      if (response.in_cart) {
        $(response.template).appendTo("body").modal("show");
      } else {
        $("#" + $thisbutton.attr("id") + "_text").html("Added");
        $thisbutton.addClass("disabled");
        $thisbutton.attr("aria-disabled", "true");
        window.location.href = EAPLUS_VARS.cart_url;
      }
      if (response.cart_total) {
      }
      if (response.error && response.plan_addons_url) {
        return;
      } else {
        $(document.body).trigger("added_to_cart", [
          response.fragments,
          response.cart_hash,
          $thisbutton,
        ]);
      }
    },
  });
  var dataLayer = (window.dataLayer = window.dataLayer || []);
  dataLayer.push({
    'event': "choose_plan",
    'client': EAPLUS_VARS.client_code,
    'tracking_code': EAPLUS_VARS.tracking_code,
    'discount': EAPLUS_VARS.discount,
    'conversion': "",
    'plan': productName,
    'coverage': variationName
  });
});

$(document).on("click", ".swap-base-product", function (e) {
  e.preventDefault();
  var $thisbutton = $(this);
  if ($thisbutton.hasClass("loading") || $thisbutton.hasClass("disabled")) {
    return;
  }
  const productID = $(this).data("product-id");
  const $productInput = $(".product-" + productID + "-input");
  const toggleData = $productInput.data(
    "toggle-switch-options"
  );
  const isChecked = $productInput.is(":checked");
  const variationID = isChecked
      ? toggleData.variation_id
      : toggleData.variation_id_default;
  var data = {
    action: "ql_woocommerce_ajax_swap_base_product",
    product_id: productID,
    product_type: "base-plan",
    quantity: 1,
    variation_id: variationID,
  };
  $(document.body).trigger("adding_to_cart", [$thisbutton, data]);
  $.ajax({
    type: "post",
    url: wc_add_to_cart_params.ajax_url,
    data: data,
    beforeSend: function (response) {
      $thisbutton.removeClass("added").addClass("loading");
    },
    complete: function (response) {
      $thisbutton.addClass("added").removeClass("loading");
    },
    success: function (response) {
      if (response.in_cart) {
        $("body").append(response.template).modal("show");
      } else {
        refresh_notices().done(function() {
          $("#" + $thisbutton.attr("id") + "_text").html("Added");
          $("#product-info-modal").modal("hide");

          window.location.href = EAPLUS_VARS.cart_url;
        });
      }
      if (response.error && response.plan_addons_url) {
        return;
      } else {
        $(document.body).trigger("added_to_cart", [
          response.fragments,
          response.cart_hash,
          $thisbutton,
        ]);
      }
    },
  });
});

$(document).on("click", ".switch-label", function(event) {
  const $this = $(this);
  const $input = $('#' + $this.attr('for'));

  if (!$input.length) {
    return;
  }

  const isInputLabel = ! $this.hasClass('switch-label-other');

  if (isInputLabel && ! $input.is(':checked') || !isInputLabel && $input.is(':checked')) {
    event.preventDefault();
  }
});

function updateProductUI(toggleData, variationId, variationName, price, priceRegular, isOnSale, promoLabel) {
  var productId = toggleData.product_id;
  var productinCart = toggleData.product_in_cart;
  var variationinCart = toggleData.variation_in_cart;

  if (productinCart == productId) {
    if (variationinCart == variationId) {
      $("a.btn.product-btn-" + productId)
        .addClass("disabled")
        .html("Added to cart");
      $("a.add-btn.product-btn-" + productId)
        .addClass("disabled")
        .removeClass("other-variation")
        .find("h2")
        .html(toggleData.product_name + " " + variationName);
    } else {
      $("a.btn.product-btn-" + productId)
        .removeClass("disabled")
        .html("Update Cart");
      $("a.add-btn.product-btn-" + productId)
        .removeClass("disabled")
        .addClass("other-variation")
        .find("h2")
        .html("Update to " + toggleData.product_name + " " + variationName);
    }
  }

  $(".product-price-" + productId)
    .html(price)
    .toggleClass('price--offer', isOnSale);
  $(".product-price-regular-" + productId)
    .html(priceRegular)
    .toggleClass('d-none', !isOnSale);
  $(".product-promo-label-" + productId).text(promoLabel || "");
  $(".product-promo-" + productId).toggleClass('d-none', !promoLabel);
  $("a.product-btn-" + productId).attr("href", function () {
    return (
      EAPLUS_VARS.enroll_now_page_url +
      "?add-to-cart=" +
      productId +
      "&variation_id=" +
      variationId
    );
  });

  $("a.add-btn.product-btn-" + productId)
    .find("h2")
    .html("Get " + toggleData.product_name + " " + variationName);
}

function applyCurrentToggleState(toggle) {
  const $toggle = $(toggle);
  const toggleData = $toggle.data("toggle-switch-options");

  if (!toggleData) {
    return;
  }

  if ($toggle.is(":checked")) {
    updateProductUI(
      toggleData,
      toggleData.variation_id,
      toggleData.variation_name,
      toggleData.variation_price,
      toggleData.variation_price_regular,
      toggleData.variation_is_on_sale,
      toggleData.variation_promo_label
    );

    return;
  }

  updateProductUI(
    toggleData,
    toggleData.variation_id_default,
    toggleData.variation_default_name,
    toggleData.price,
    toggleData.price_regular,
    toggleData.is_on_sale,
    toggleData.promo_label
  );
}

$(document).on("change", ".switch-input", function () {
  var current_element = $(this);
  var current_state = $(this).is(":checked");

  applyCurrentToggleState(current_element);

  sync_toggle(current_element, current_state);
});

function sync_toggle(element, state) {
  var toggles = $(".switch-input").not(element);
  $(toggles).each(function () {
    var toggle = $(this);
    if ($(toggle).is(":checked") != state) {
      $(toggle).prop("checked", state);
    }

    applyCurrentToggleState(toggle);
  });
}

var initialToggle = $(".switch-input").filter(":checked").first();
if (!initialToggle.length) {
  initialToggle = $(".switch-input").first();
}
if (initialToggle.length) {
  applyCurrentToggleState(initialToggle);
  sync_toggle(initialToggle, initialToggle.is(":checked"));
}

//Setup AJAX call refreshing notices
var $notices_refresh = {
  url: wc_add_to_cart_params.wc_ajax_url
    .toString()
    .replace("%%endpoint%%", "get_notices"),
  type: "GET", // might deliver cached data
  timeout: 5000,
  success: function (data) {
    if (data && data.notices) {
      // Remove existing notices
      $(".woocommerce-error, .woocommerce-message, .woocommerce-info").remove();
      // Add new notices
      $(".woocommerce-notices-wrapper:first").prepend(data.notices);

      $(document.body).trigger("wc_notices_refreshed");
    }
  },
  error: function () {
    $(document.body).trigger("wc_notices_ajax_error");
  },
};

/* Named callback for refreshing notices */
function refresh_notices() {
  return $.ajax($notices_refresh);
}

// required to refresh woocommerce notices for OceanWP ajax add to cart.
$("body").on("adding_to_cart", function () {
  refresh_notices();
});

$("body").on("wc_notices_refreshed", function () {});
